import React from 'react';
import './Item.css';
import { Link } from 'react-router-dom';

const Item = ({ id, name, image, oldPrice, newPrice }) => {
    const handleClick = () => {
        window.scrollTo(0, 0);
    };

    return (
        <div className="item">
            <Link to={`/product/${id}`} onClick={handleClick}>
                <img src={image} alt={name} />
            </Link>
            <h3>{name}</h3>
            <div className="prices">
                {oldPrice && <div className="oldPrice">Ksh. {oldPrice}</div>}
                <div className="newPrice">Ksh. {newPrice}</div>
            </div>
        </div>
    );
};

export default Item;